import styled from 'styled-components';
import { Subtitle } from 'components';
import { px2rem } from 'src/util';

export const StyledSubtitle = styled(Subtitle)`
  @media screen and (min-width: 998px) {
    margin-bottom: ${px2rem(24)};
  }

  @media screen and (max-width: 997px) {
    font-size: 16px;
    margin-bottom: 16px;
  }
`;

export const LogoList = styled.div`
  align-items: center;
  display: flex;
  height: ${px2rem(32)};
`;

export const Logo = styled.img`
  height: 100%;

  &:not(:last-of-type) {
    margin-right: ${px2rem(40)};
  }
`;
